import * as React from "react";

import { SelectEditorFactory } from "../Html/Factories/SelectEditorFactory";

import { ISelectEditorProps } from "../Html/SelectEditor";
import Content from "./Resources/ContentContent";

export interface IYearDropdownProps {
    onChange: (year: number) => void;
    year: number;
    maxYear?: number;
    minYear?: number;
}

export interface IYearDropdownState {}

export class YearDropdown extends React.Component<IYearDropdownProps, IYearDropdownState> {
    constructor(props: IYearDropdownProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const minYear = this.props.minYear ? this.props.minYear : new Date().getFullYear() - 150;
        const maxYear = this.props.maxYear ? this.props.maxYear : new Date().getFullYear() + 150;

        // TODO - resources
        const YearSelectEditor = SelectEditorFactory.create<number>();
        const yearSelectEditorProps: ISelectEditorProps<number> = {
            ariaLabel: Content.Year,
            required: Content.Please_select_a_year,
            selected: this.props?.year <= minYear ? minYear : this.props.year,
            options: this.getOptions(minYear, maxYear),
            getText: (year: number) => year.toString(),
            onChange: (year: number) => this.onChange(year),
        };

        return (
            <div className="header-row year">
                <YearSelectEditor {...yearSelectEditorProps} />
            </div>
        );
    }

    private getOptions(min: number, max: number): number[] {
        const options = [];
        for (let y = max; y >= min; y--) {
            options.push(y);
        }
        return options;
    }

    private onChange(year: number): void {
        if (year !== this.props.year) {
            return this.props.onChange(year);
        }
    }
}
